import React, { useEffect, useState } from "react";
//import { Link } from "react-router-dom";
//import parse from "html-react-parser";
import {
  MiniAquaSquare,
  MiniGreenTriangle,
  MiniOrangeTriangle,
  MiniYellowSquare,
  PurpleDiamond,
  PurpleTriangle,
  BlueCircle,
  GreenSquare,
} from "../../assets/shapes";
import { formatUrl } from "../../util/format-url";

export default function OverviewView(props: any) {
  const { navList } = props;
  //const [components, setComponents] = useState([]);
  const [guides, setGuides] = useState([]);
  //console.log("navList", navList, "pages", pages);
  useEffect(() => {
    if (navList) {
      //var tempComponents: any = [];
      var tempGuides: any = [];
      navList.forEach((group: any) => {
        /*if (group.name === "Components") {
          tempComponents = group.items;
        }*/
        if (group.name === "Guides") {
          tempGuides = group.items;
        }
      });
      //setComponents(tempComponents);
      setGuides(tempGuides);
    }
    //console.log("tempComponents", tempComponents, components);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="custom-website-wrap">
      <div className="custom-website-header">
        <div className="custom-website-header-title">Overview</div>
        <div className="custom-website-header-subtitle">Explore Ikigai</div>
        {
          <>
            <PurpleDiamond />
            <MiniOrangeTriangle />
            <PurpleTriangle />
            <MiniAquaSquare />
            <MiniYellowSquare />
            <BlueCircle />
            <MiniGreenTriangle />
            <GreenSquare />
          </>
        }
      </div>
      <div className="custom-website-body">
        <div className="custom-website-body-inner">
          <div className="custom-website-body-inner-section">
            <div className="custom-website-body-inner-section-title">
              Start with the basics
            </div>
            <div className="break"></div>
            <a
              className="custom-website-body-card overview color-1"
              href={`/getting-started/tutorial`}
            >
              <div className="custom-website-body-card-name">
                Getting Started
              </div>
              <div className="custom-website-body-card-descr">
                Learn by building a quick sample app
              </div>
            </a>
            <a
              className="custom-website-body-card overview color-2"
              href={`/api/time-series-api`}
            >
              <div className="custom-website-body-card-name">
                Time Series API
              </div>
              <div className="custom-website-body-card-descr">
                Build enterprise AI Apps with APIs
              </div>
            </a>
          </div>
          <div className="horizontal-divider sm"></div>
          <div className="custom-website-body-inner-section components">
            <div className="custom-website-body-inner-section-title">
              Guides
            </div>
            <div className="custom-website-body-inner-section-subtitle">
              Learn by following simple guides
            </div>
            <div className="break"></div>
            {guides &&
              guides.map((guide: any, count: number) => (
                <a
                  className={`custom-website-body-card component color-${count}`}
                  href={`/guides/${formatUrl(guide.name)}`}
                >
                  <div className="custom-website-body-card-icon">
                    {guide.icon && (
                      <img
                        src={guide.icon}
                        alt={guide.name + " icon"}
                        width=""
                        height=""
                      />
                    )}
                  </div>
                  <div className="custom-website-body-card-name">
                    {guide.name}
                  </div>
                </a>
              ))}
          </div>
          {/* <div className="custom-website-body-inner-section guides">
            <div className="custom-website-body-inner-section-title">
              Guides
            </div>
            <div className="custom-website-body-inner-section-subtitle">
              Learn by following simple guides
            </div>
            <div className="break"></div>
            {guides &&
              guides.map((guide: any, count: number) => (
                <a
                  className={`custom-website-body-card guide`}
                  href={`/guides/${formatUrl(guide.name)}`}
                >
                  <div className="custom-website-body-card-name">
                    {guide.name}
                  </div>
                </a>
              ))}
          </div> */}
          {/* <div className="horizontal-divider sm"></div>
          <div className="custom-website-body-inner-section component">
            <div className="custom-website-body-inner-section-title">
              Get familiar with Components - building blocks in Ikigai
            </div>
            <div className="break"></div>
            {components &&
              components.map((component: any, count: number) => (
                <a
                  className={`custom-website-body-card component color-${count}`}
                  href={`/components/${formatUrl(component.name)}`}
                >
                  <div className="custom-website-body-card-icon">
                    {component.icon && (
                      <img
                        src={component.icon}
                        alt={component.name + " icon"}
                        width=""
                        height=""
                      />
                    )}
                  </div>
                  <div className="custom-website-body-card-name">
                    {component.name}
                  </div>
                </a>
              ))}
          </div> */}
        </div>
      </div>
      <div className="custom-website-footer"></div>
    </div>
  );
}
